/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

export { default as ToastNeutral } from './toast-neutral-story';
export { default as ToastSuccess } from './toast-success-story';
export { default as ToastDanger } from './toast-danger-story';
export { default as ToastAction } from './toast-action-story';
export { default as ToastCloseable } from './toast-closeable-story';
export { default as ToastProgressBar } from './toast-progress-bar';
export { default as ToastCustom } from './toast-custom-story';
export { default as ToastControlled } from './toast-controlled-story';

import { removeLicenseHeader } from '../../_common/export-stories-utils';
import ToastActionSrcRaw from './toast-action-story?raw';
import ToastCloseableSrcRaw from './toast-closeable-story?raw';
import ToastControlledSrcRaw from './toast-controlled-story?raw';
import ToastCustomSrcRaw from './toast-custom-story?raw';
import ToastDangerSrcRaw from './toast-danger-story?raw';
import ToastNeutralSrcRaw from './toast-neutral-story?raw';
import ToastProgressBarSrcRaw from './toast-progress-bar?raw';
import ToastSuccessSrcRaw from './toast-success-story?raw';

export const ToastNeutralSrc = removeLicenseHeader(ToastNeutralSrcRaw);
export const ToastSuccessSrc = removeLicenseHeader(ToastSuccessSrcRaw);
export const ToastDangerSrc = removeLicenseHeader(ToastDangerSrcRaw);
export const ToastActionSrc = removeLicenseHeader(ToastActionSrcRaw);
export const ToastCloseableSrc = removeLicenseHeader(ToastCloseableSrcRaw);
export const ToastProgressBarSrc = removeLicenseHeader(ToastProgressBarSrcRaw);
export const ToastCustomSrc = removeLicenseHeader(ToastCustomSrcRaw);
export const ToastControlledSrc = removeLicenseHeader(ToastControlledSrcRaw);
